// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footerContainer--SUxKe";
export var iconList = "footer-module--iconList--AjLF4";
export var icons = "footer-module--icons--3xW3b";